const resources = {
  tonnage_tickets: {
    name: 'tonnage ticket |||| tonnage tickets',
    contextualType: 'tonnage',
    fields: {
      ticket_number: 'ticket #',
      worked_at_date: 'date',
      net_weight_in_tons: 'tons',
      snapshot_mode: 'archived?',
      broker_driver_pay_rollup_period_end_date: 'week end',
      total_pay_in_dollars: 'earned',
      ticket_image_url: 'image',
      sender: 'sender',
    },
  },
  hourly_tickets: {
    name: 'hourly ticket |||| hourly tickets',
    contextualType: 'hourly',
    fields: {
      ticket_number: 'ticket #',
      worked_at_date: 'date',
      regular_time_in_hours: 'reg hrs',
      overtime_in_hours: 'OT hours',
      doubletime_in_hours: 'DT hours',
      snapshot_mode: 'archived?',
      broker_driver_pay_rollup_period_end_date: 'week end',
      total_pay_in_dollars: 'earned',
      ticket_image_url: 'image',
      sender: 'sender',
    },
  },
  broker_driver_pay_rollups: {
    name: 'earning |||| earnings',
    fields: {
      driver: {
        name: 'driver',
      },
      period: {
        end_date: 'week end',
      },
      tonnage_total_in_dollars: 'tonnage',
      hourly_total_in_dollars: 'hourly',
      total_in_dollars: 'total',
      total_line_item_quantity: 'tickets',
    }
  },
  driver_pay_rollup_tickets: {
    name: 'ticket |||| tickets',
    fields: {
      ticket_number: 'ticket #',
      net_weight_in_tons: 'tons',
      date: 'date',
      tonnage_pay_rate_in_dollars: 'ton haul rate',
      fuel_surcharge_in_dollars: 'fuel',
      material_surcharge_in_dollars: 'mtrl',
      total_pay_in_dollars: 'total',
      haul_time_in_hours: 'Haul hr',
      haul_pay_rate_in_dollars: 'Haul rate',
      convey_time_in_hours: 'Convey hr',
      convey_pay_rate_in_dollars: 'Convey rate',
      equipment_time_in_hours: 'Eqpt hr',
      equipment_pay_rate_in_dollars: 'Eqpt rate',
      wait_time_in_hours: 'Travel hr',
      wait_pay_rate_in_dollars: 'Travel rate',
      regular_time_in_hours: 'reg hr',
      regular_pay_rate_in_dollars: 'reg rate',
      overtime_in_hours: 'OT hr',
      doubletime_in_hours: 'DT hr',
      overtime_pay_rate_in_dollars: 'OT rate',
      doubletime_pay_rate_in_dollars: 'DT rate',
      travel_pay_in_dollars: 'travel',
      equipment_rate_in_dollars: 'ton convey rate',
      customer_name: 'customer',
      truck_number: 'truck',
      dropoff_site: 'dropoff',
      pickup_site: 'pickup',
      material: 'material',
    },
    lines: {
      flat_rate: 'F',
    }
  },
  periods: {
    name: 'period |||| periods',
  },
  users: {
    name: 'account',
    fields: {
      username: 'username',
      new_password: 'new password',
      old_password: 'old password',
    },
  },
  broker_drivers: {
    fields: {
      name: 'name',
      num_available_trucks: 'number of available trucks',
    },
    info: {
      num_available_trucks: 'Enter number of trucks available to %{tenantName} for the date shown. The number will remain until you change it. Date updates to the following day at %{time} %{timeZone}.',
    },
  },
  tonnage_dispatches: {
    name: 'tonnage order |||| tonnage orders',
    fields: {
      num_trucks: '# Trucks',
      broker_rates: 'Rates',
      broker_base_rate_in_dollars: 'haul',
      broker_equipment_rate_in_dollars: 'convey',
      broker_fuel_surcharge_in_dollars: 'fuel',
      broker_material_surcharge_in_dollars: 'material',
      start_at: 'start at',
      end_at: 'end at',
      load_at: 'load at',
      notes: 'notes',
      order: {
        order_number: 'order #',
      },
      material: {
        name: 'material',
      },
      dropoff_site: {
        name: 'dropoff',
      },
      pickup_site: {
        name: 'pickup',
      },
      recipient: {
        name: 'recipient',
      },
      customer: {
        name: 'customer',
      },
      terminal: {
        name: 'terminal',
      },
    },
    print: {
      title: 'Haulz - Tonnage',
    },
  },
  hourly_dispatches: {
    name: 'hourly order |||| hourly orders',
    fields: {
      broker_haul_rate_in_dollars: 'haul',
      broker_convey_rate_in_dollars: 'convey',
      broker_equipment_rate_in_dollars: 'equipment',
      broker_wait_rate_in_dollars: 'travel',
      broker_overtime_rate_in_dollars: 'overtime',
      broker_doubletime_rate_in_dollars: 'doubletime',
      broker_rates: 'rates',
      num_trucks: '# Trucks',
      notes: 'notes',
      start_at: 'start at',
      end_at: 'end at',
      load_at: 'load at',
      order: {
        order_number: 'order #',
      },
      pickup_site: {
        name: 'pickup',
      },
      hourly_work_type: {
        name: 'work type',
      },
      dropoff_site: {
        name: 'dropoff',
      },
      material: {
        name: 'material',
      },
      customer: {
        name: 'customer',
      },
      terminal: {
        name: 'terminal',
      },
    },
    print: {
      title: 'Haulz - Hourly',
    },
  },

  dispatches: {
    name: 'order |||| orders',
    form: {
      acceptButton: 'Accept',
      declineButton: 'Decline',
      confirmButton: 'Confirm',
      confirmedMessage: 'You have confirmed this order.',
      acceptedStatusMessage: 'You have accepted this order.',
      declinedStatusMessage: 'You have declined this order.',
      changeToAcceptedAction: 'Change to accept',
      changeToDeclinedAction: 'Change to decline',

      completeButton: 'Mark complete',
      completedStatusMessage: 'You have marked this order complete.',
      undoCompleteAction: 'Undo',

      cancelConfirmedStatusMessage: 'This order has been canceled. You have confirmed.',
      confirmCancelButton: 'Click to confirm',
      awaitingCancelConfirmationStatusMessage: 'This order has been canceled.',

      suspendedStatusMessage: 'This order has been suspended.',
      confirmSuspendButton: 'Click to confirm',
      suspendConfirmedStatusMessage: 'This order has been suspended. You have confirmed.',
    },
  },
}

export default {
  resources,
}
